import {PANEL_SET_PARAMS, BATCH_ACTIONS} from '~/frontend/src/constants';
import setParam from '~/frontend/src/actions/panel/common/setParam';


export type SetParamsAction = {
    type : typeof PANEL_SET_PARAMS;
    subType : typeof BATCH_ACTIONS;
    panelKey : string;
    panelProps: object;
    actions : object[];
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {object} panelProps
 *
 * @return {SetParamsAction}
 */
export default function setParams( panelKey : string, panelProps : object ) : SetParamsAction {
    const actions : object[] = [],
          panelPropsKeys     = Object.keys( panelProps );

    for ( const panelPropKey of panelPropsKeys ) {
        actions.push( setParam( panelKey, panelPropKey, panelProps[ panelPropKey ] ) );
    }

    return {
        type   : PANEL_SET_PARAMS,
        subType: BATCH_ACTIONS,
        panelKey,
        panelProps,
        actions
    };
}

export type SetParams = typeof setParams;
